export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_02_Loop.b90558a5.mp4";